import React, { useState } from 'react';
import { Lightbulb, ChevronDown, ChevronUp } from 'lucide-react';

export const MoonHowToUse: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="mb-6">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 rounded-lg bg-secondary/50 border border-border/50 hover:bg-secondary/80 transition-colors text-left"
      >
        <div className="flex items-center gap-2 text-sm">
          <Lightbulb className="w-4 h-4 text-gold flex-shrink-0" />
          <span className="text-muted-foreground">
            <span className="font-medium text-foreground">Tip:</span> Full moon is best for lunar photography. Shoot during twilight for dramatic compositions.
          </span>
        </div>
        {expanded ? (
          <ChevronUp className="w-4 h-4 text-muted-foreground flex-shrink-0" />
        ) : (
          <ChevronDown className="w-4 h-4 text-muted-foreground flex-shrink-0" />
        )}
      </button>

      {expanded && (
        <div className="mt-2 px-4 py-4 rounded-lg bg-secondary/30 border border-border/50 text-sm text-muted-foreground">
          <div className="grid sm:grid-cols-2 gap-4">
            <ul className="space-y-2">
              <li>Plan shoots during full moon phases (90%+ illumination)</li>
              <li>Supermoons appear ~14% larger — great for dramatic shots</li>
              <li>Shoot during moonrise/moonset for foreground compositions</li>
              <li>Golden & blue hour overlap creates stunning color in the sky</li>
            </ul>
            <ul className="space-y-2">
              <li>Use telephoto lenses (200mm+) for detailed lunar surface shots</li>
              <li>Higher altitude = less atmospheric distortion, clearer images</li>
              <li>Check azimuth direction to plan your shooting position</li>
              <li>Max altitude time tells you when the moon is highest and sharpest</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
